/**
 * @generated SignedSource<<29a85a2db23a704cd1ba4b3dd9e0c71f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type lockCouponsHubQuery$variables = {
  hubName: string;
};
export type lockCouponsHubQuery$data = {
  readonly hubMeta: {
    readonly hub: {
      readonly id: string;
    } | null | undefined;
    readonly id: string;
  } | null | undefined;
};
export type lockCouponsHubQuery = {
  response: lockCouponsHubQuery$data;
  variables: lockCouponsHubQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hubName"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "hubName"
          }
        ],
        "kind": "ObjectValue",
        "name": "by"
      }
    ],
    "concreteType": "HubMeta",
    "kind": "LinkedField",
    "name": "hubMeta",
    "plural": false,
    "selections": [
      (v1/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Hub",
        "kind": "LinkedField",
        "name": "hub",
        "plural": false,
        "selections": [
          (v1/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "lockCouponsHubQuery",
    "selections": (v2/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "lockCouponsHubQuery",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "794a71d3d5a34cda948a67d405d99ec0",
    "id": null,
    "metadata": {},
    "name": "lockCouponsHubQuery",
    "operationKind": "query",
    "text": "query lockCouponsHubQuery(\n  $hubName: String!\n) {\n  hubMeta(by: {name: $hubName}) {\n    id\n    hub {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "06a8cff47dc156b5aada65e20c9c9045";

export default node;
